// import SortUp from "../../../sortUpBlack.png";
import ArrowUpIcon from '../Assets/ArrowUpIcon'
import ArrowDownIcon from '../Assets/ArrowDownIcon'

const Filter = ({ setSort, sort, keys, onChange }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
      onClick={() => {
        // if (sort === 1) setSort((prev) => ({ ...prev, [keys]: 2 }));
        // else if (sort === 2) setSort((prev) => ({ ...prev, [keys]: null }));
        // else setSort((prev) => ({ ...prev, [keys]: 1 }));
        // onChange();
      }}
    >
      {/* <img
        style={{
          marginBottom: "-6px",
        }}
        src={
          sort === 1 ? "../../../sortUpBlack.png" : "../../../sortUpGrey.png"
        }
        alt="sort up"
      /> */}
      
      <div  style={{ marginBottom: "-6px" }} >
        { sort === 1 ? <ArrowUpIcon color='black' /> : <ArrowUpIcon color='gray' />}
      </div>

      {/* <img
        style={{
          marginTop: "-6px",
        }}
        src={
          sort === 2
            ? "../../../sortDownBlack.png"
            : "../../../sortDownGrey.png"
        }
        alt="sort down"
      /> */}
      <div style={{ marginBottom: "-6px" }} >
        {sort === 2
            ? <ArrowDownIcon color='black' />
            : <ArrowDownIcon color='gray' />
        }
      </div>
    </div>
  );
};

export default Filter;
